// extracted by mini-css-extract-plugin
module.exports = {"search__plus":"_30cywdbTcftNoFDHVm47iD","plus_icon":"_3zO37AlYA3yTYQMESA1HYv","tooltip":"_1qCIWtJYNyd0nZbE25RtQA"};